import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './Toast.css'; 

const Toast = ({ type, message, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    const fadeOutTimer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(fadeOutTimer);
    };
  }, [onClose]);

  const icon = type === 'success' ? <FaCheckCircle /> : <FaTimesCircle />;

  return (
    <div className={`toast ${type} ${!isVisible ? 'fade-out' : ''}`}>
      {icon}
      <span>{message}</span>
    </div>
  );
};

export default Toast;
